import { createAsyncThunk } from '@reduxjs/toolkit';
import { G as GetProduct, a as GetProductDynamic } from '../../GetProductDynamic-c7C5vG1y.js';
import { p as publicQuery } from '../../requestsCollection-mMBLWoZb.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';

const getProduct = createAsyncThunk('product/getProduct', async ({ urlKey, ctx }, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await publicQuery(apolloConfig(ctx.locale), {
            query: GetProduct,
            variables: {
                urlKey,
                locale: ctx.locale,
            },
        }, 'GetProduct', ctx);
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        const product = data.products.items[0];
        if (!product) {
            return rejectWithValue({
                errorMessage: 'notFound',
            });
        }
        return product;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const getProductDynamic = createAsyncThunk('product/getProductDynamic', async ({ urlKey }, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await publicQuery(apolloConfig(), {
            query: GetProductDynamic,
            variables: {
                urlKey,
            },
        }, 'GetProductDynamic');
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        const product = data.products.items[0];
        if (!product) {
            return rejectWithValue({
                errorMessage: 'notFound',
            });
        }
        return product;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { getProduct, getProductDynamic };
//# sourceMappingURL=thunks.js.map
